import type { SpreadTemplate } from "../types";
import { BASE_SPREAD_TEMPLATES } from "./base";

// English comment: A5 portrait spread templates (start from base; adjust manually later)
export const SPREADS_A5_PORTRAIT: SpreadTemplate[] = BASE_SPREAD_TEMPLATES.map((b) => ({
  id: `a5p_${b.idSuffix}`,
  name: b.name,
  format_group: "a5_portrait",
  unitKind: "spread",
  blocks: b.blocks
}));
